import { Fade, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { generateUUID } from "../../utility/uuid";
import { FunctionComponent, useEffect, useState } from "react";
import { createAdministrationItemList, createBiItemList, createChatItemList, createServiceItemList, createSettingsRestaurantItemList } from "./CreateItemList";
import UserAuthenticated from "../../auth/UserAuthenticated";
import { useNavigate } from "react-router-dom-v5-compat";

interface Props {
    url: string;
    ristoranteId: string;
    onClose: () => void;
    isMobileAndOpened: boolean;
}

export const MobileVerticalNavBar: FunctionComponent<Props> = (props: Props) => {
    const macroAreaListItem: any[] = [];

    if (UserAuthenticated.getInstance().abilitaModuloChat) {
        macroAreaListItem.push(
            {
                text: "Chat",
                urlContains: "chat",
            }
        );
    }

    macroAreaListItem.push(
        {
            text: "BI",
            urlContains: "bi",
        }
    );
    macroAreaListItem.push(
        {
            text: "Amministrazione",
            urlContains: "myAccount",
        }
    );

    if (UserAuthenticated.getInstance().abilitaModuloServizio) {
        macroAreaListItem.push(
            {
                text: "Servizio",
                urlContains: "servizio",
            }
        );
    }

    macroAreaListItem.push(
        {
            text: "Impostazioni",
            urlContains: "impostazioni",
        }
    );

    const [selectedMacroArea, setSelectedMacroArea] = useState<string>("");
    const [currentItemList, setCurrentItemList] = useState<any[]>([]);

    const navigate = useNavigate();

    // Funzione per selezionare la lista corretta in base al macro-area e all'ID del ristorante
    const getItemList = (macro: string, ristoranteId: string) => {
        switch (macro) {
            case "bi":
                return createBiItemList(ristoranteId, navigate);
            case "myAccount":
                return createAdministrationItemList(ristoranteId, navigate);
            case "servizio":
                return createServiceItemList(ristoranteId, navigate);
            case "chat":
                return createChatItemList(ristoranteId, navigate);
            case "impostazioni":
                return createSettingsRestaurantItemList(ristoranteId, navigate);
            default:
                return [];
        }
    };

    useEffect(() => {
        // Imposta il macro-area in base all'URL corrente
        const found = macroAreaListItem.find((item) =>
            props.url.includes(item.urlContains)
        );
        if (found) {
            setSelectedMacroArea(found.urlContains);
        }
    }, [props.url]);

    useEffect(() => {
        // Aggiorna la lista corrente ogni volta che cambia il macro-area o l'ID del ristorante
        const items = getItemList(selectedMacroArea, props.ristoranteId);
        setCurrentItemList(items);
    }, [selectedMacroArea, props.ristoranteId]);

    const handleMacroAreaClick = (item: { text: string; urlContains: string }) => {
        setSelectedMacroArea(item.urlContains);
    };

    const handleItemClick = (onClick: () => void) => {
        onClick();
        props.onClose();
    };

    return (
        <Fade in={props.isMobileAndOpened} timeout={300} unmountOnExit>
            <Stack
                sx={theme => ({
                    position: "absolute",
                    left: 0,
                    top: 64,
                    bottom: 0,
                    right: 0,
                    zIndex: 1000,
                    p: 1,
                    backgroundColor: theme.palette.background.paper,
                })}
            >
                <Stack sx={{
                    backgroundColor: "rgb(249, 250, 251)",
                    border: "1px solid rgb(236, 236, 241)",
                    borderRadius: 2,
                    height: "100%"
                }}>
                    <Stack direction={"row"} sx={{
                        p: 1,
                        gap: 1,
                        overflowY: "scroll",
                        borderBottom: "1px solid rgb(236, 236, 241)",
                    }}>
                        {
                            macroAreaListItem.map((item) => (
                                <Stack
                                    key={generateUUID()}
                                    onClick={() => handleMacroAreaClick(item)}
                                    sx={{
                                        p: 1,
                                        px: 2,
                                        backgroundColor:
                                            selectedMacroArea === item.urlContains ? grey[300] : "transparent",
                                        borderRadius: 2,
                                        cursor: "pointer",
                                    }}
                                >
                                    <Typography>{item.text}</Typography>
                                </Stack>
                            ))
                        }
                    </Stack>

                    <Stack sx={{ p: 2, gap: 1 }}>
                        {
                            currentItemList.map((section) => (
                                <Stack key={generateUUID()} spacing={1}>
                                    {section.title && (
                                        <Typography variant="subtitle1">{section.title}</Typography>
                                    )}
                                    {section.items.map((item: any) => (
                                        <Stack
                                            key={generateUUID()}
                                            onClick={() => handleItemClick(item.onClick)}
                                            sx={{
                                                p: 1,
                                                px: 2,
                                                borderRadius: 2,
                                                cursor: "pointer",
                                            }}
                                        >
                                            <Typography>{item.text}</Typography>
                                        </Stack>
                                    ))}
                                </Stack>
                            ))
                        }
                    </Stack>
                </Stack>
            </Stack>
        </Fade>
    );
};
